export default __webpack_public_path__ + "static/media/minus-in-circle.eac15bac.svg";